module.exports = __webpack_public_path__ + "img/ic_youtube.8d53631e.svg";